import EastIcon from "@mui/icons-material/East"
import { Stack, Typography } from "@mui/material"
import router from "next/router"
import { FC, useMemo, useState } from "react"

import { Button } from "src/components/common/button"
import { create } from "src/helpers/bem"
import { deepClone } from "src/helpers/deepClone"
import { useTranslation } from "src/hooks/translation"

import { getFormById } from "src/queriesXRM/form"
import { BookingDetails, useBooking } from "src/states/bookingDetail"
import { mergeBookingDetailPermissions } from "src/states/bookingDetailPermissions"
import { useBookings } from "src/states/bookings"
import { useLocale } from "src/states/locale"

import { resetSalesorder, setSalesorderSteps } from "src/states/salesorder"
import { SharedPageProps } from "src/types/SharedPageProps"
import { xRMApiStep } from "src/types/xRM"

import styles from "./BookingOverview.module.scss"

const bem = create(styles, "BookingOverview")

export interface BookingOverviewProps extends SharedPageProps {
  bookingId: string
}

export const BookingOverview: FC<BookingOverviewProps> = ({
  bookingId,
  pages,
  messages,
}) => {
  const { messages: translations } = useTranslation()
  const { bookings } = useBookings()
  const { booking: bookingDetail, coExhibitors } = useBooking()
  const locale = useLocale()
  const bookingLabels = translations.pages.booking.detail
  const activeBooking = bookings.find((booking) => booking.id === bookingId)
  const data = [
    {
      label: bookingLabels.exhibition.exhibitionName,
      value: activeBooking?.exhibition ?? "",
    },
    {
      label: bookingLabels.exhibition.exhibitor,
      value: activeBooking?.exhibitor ?? "",
    },
    {
      label: bookingLabels.exhibition.createdOn,
      value: activeBooking?.createdOn ?? "",
    },
    {
      label: bookingLabels.exhibition.coExhibitor,
      value: coExhibitors.length ?? "",
    },
  ]

  const [loading, setLoading] = useState(false)

  const redirectBookingForm = useMemo(
    () =>
      pages?.data?.nodes?.filter(
        (page) =>
          page?.language?.slug === locale &&
          page?.template?.templateName === "Booking Form Template",
      )?.[0],
    [pages, locale],
  )

  const openBookingAsCopy = async () => {
    {
      setLoading(true)
      const formResultAsDraft = await getFormById(
        activeBooking?.id ?? "",
        "Main",
        "Draft",
        process.env.NEXT_PUBLIC_XRM_EVENT_ID,
      )

      const data = JSON.parse(formResultAsDraft?.currentForm) as BookingDetails
      const steps = deepClone<xRMApiStep[]>(data.steps)

      resetSalesorder()
      setSalesorderSteps(steps)

      await router.push(redirectBookingForm?.uri as string).finally(() => {
        setLoading(false)
      })
    }
  }
  return (
    <Stack className={bem("card")} direction={"column"}>
      <Stack
        className={bem("card", "content")}
        direction={"row"}
        justifyContent={"space-between"}
        spacing={2}
      >
        <Stack direction={"column"}>
          {data.map((item) => (
            <Stack
              key={item.label}
              className={bem("data")}
              direction={"row"}
              justifyContent={"flex-start"}
            >
              <Typography variant={"body1"}>{item.label}:</Typography>
              <Typography variant={"body1"}>{item.value}</Typography>
            </Stack>
          ))}
        </Stack>
        <Stack direction={"column"} spacing={2}>
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon />}
            title={bookingLabels.banner.buttonPermission}
            onClick={() => mergeBookingDetailPermissions({ open: true })}
          />
          {/* {bookingDetail?.phase && (
            <span className={bem("status", bookingDetail.phase)}>
              {(messages.pages.booking.overview.table.phase.items as any)?.[
                bookingDetail.phase
              ] ?? bookingDetail.phase}
            </span>
          )}
          {bookingDetail?.phase === "Draft" && (
            <Button
              buttonType="primary"
              className={bem("button")}
              endIcon={<EastIcon fontSize="small" />}
              title={bookingLabels.banner.buttonDraft}
              onClick={() => {
                mergeBookingDetail({ bookingFormOpen: true })
              }}
            />
          )}
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon fontSize="small" />}
            title={bookingLabels.banner.buttonAddCoExhibitor}
            onClick={() =>
              mergeCoExhibitorInvite({
                open: true,
              })
            }
          />
          <Button
            buttonType="primary"
            className={bem("button")}
            endIcon={<EastIcon />}
            title={bookingLabels.banner.buttonCopy}
            onClick={() => openBookingAsCopy()}
          /> */}
        </Stack>
      </Stack>
    </Stack>
  )
}
// Call to actions:
// (print)
// (reklamieren)
// (cancel)
